import { useTranslation } from 'react-i18next';
import Button from '../../../../../../common/widgets/Button';
import Icons from '../../../../../../common/widgets/Icons';
import { resources } from '../../../../resources/resources';
import { InvoicingAddress } from '../../../Common/Dialogs/InvoicingAddress/types';

interface InvoicingAddressSummaryProps {
  invoicingAddress: InvoicingAddress;
  onEditClick: () => void;
}

export const InvoicingAddressSummary = (
  props: InvoicingAddressSummaryProps,
) => {
  const { invoicingAddress, onEditClick } = props;

  const { t: translate } = useTranslation();

  return (
    <div className="invoicing-address-container">
      <div className="invoicing-address-summary-content active">
        <div className="invoicing-address-summary-header">
          <span className="invoicing-address-summary-name">
            {invoicingAddress.firstName} {invoicingAddress.lastName}
          </span>
          <Button
            className="btn btn-outline btn-edit-invoicing-address"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              onEditClick();
            }}
            icon={<Icons.EditInvoicing />}
          >
            <span className="btn-text">
              {translate(resources.invoicingAddress.account.editButton)}
            </span>
          </Button>
        </div>

        <div className="invoicing-address-summary-details">
          <div>
            <span className="invoicing-address-summary-label">
              {translate(
                resources.invoicingAddress.cart.invoicingAddress.address,
              )}
              :{' '}
            </span>
            {invoicingAddress.addressLine}
          </div>
          <div>
            <span className="invoicing-address-summary-label">
              {translate(resources.invoicingAddress.cart.invoicingAddress.city)}
              :{' '}
            </span>
            {invoicingAddress.city.text}
          </div>
          <div>
            <span className="invoicing-address-summary-label">
              {translate(
                resources.invoicingAddress.cart.invoicingAddress.county,
              )}
              :{' '}
            </span>
            {invoicingAddress.county.text}
          </div>
        </div>
      </div>
    </div>
  );
};
